/* eslint-disable array-callback-return */ /* eslint-disable
array-callback-return */
<template>
  <add-edit-dialog>
    <crm-panel title="新增拜访">
      <div class="page-buttons">
        <crm-button :text="'保存'" @click="handleSave()"> </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCancel()"
        >
        </crm-button>
      </div>
      <el-form
        label-width="160px"
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访对象：" prop="visitObject">
              <el-select
                clearable
                :disabled="!addForm.canEdit"
                v-model="addForm.visitObject"
                @change="handleSelectVisitObject"
              >
                <visit-object-select-types
                  :medicalType="visitAuth.visitMedicalCustomer.toggleStatus"
                  v-once
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="addForm.visitObject === 1">
            <visit-cusname-select
              v-if="addForm.customVisible"
              :val="addForm.customerId"
              @change="handleSelectCustomer"
            >
            </visit-cusname-select>
            <el-form-item
              v-if="!addForm.customVisible"
              label="客户名称："
              :rules="{ required: true }"
            >
              <el-input v-model="addForm.customName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="addForm.visitObject === 4">
            <visit-medical-cusname-select
              v-if="addForm.medicalCustomVisible"
              :val="addForm.medicalCustomerId"
              @change="handleSelectMedicalCustomer"
            >
            </visit-medical-cusname-select>
            <el-form-item
              v-if="!addForm.medicalCustomVisible"
              label="医生名称："
              :rules="{ required: true }"
            >
              <el-input v-model="addForm.medicalCustomName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="addForm.visitObject === 2">
            <visit-busi-select
              v-if="addForm.buisVisible"
              :val="addForm.businessId"
              @change="handleSelectBusiness"
            >
            </visit-busi-select>
            <el-form-item
              v-if="!addForm.buisVisible"
              label="商机名称："
              prop="businessName"
              :rules="{ required: true }"
            >
              <el-input v-model="addForm.businessName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="addForm.visitObject === 3">
            <visit-clues-select
              v-if="addForm.cluesVisible"
              :val="addForm.cluesId"
              @change="handleSelectClues"
            >
            </visit-clues-select>
            <el-form-item
              v-if="!addForm.cluesVisible"
              label="线索名称："
              prop="cluesName"
              :rules="{ required: true }"
            >
              <el-input
                v-model="addForm.cluesName"
                size="medium"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="业务员：" prop="salesmanCode">
              <el-select
                clearable
                filterable
                :disabled="!addForm.canEdit"
                @change="handleSelectSalesman"
                v-model="addForm.salesmanCode"
                value-key="code"
              >
                <el-option
                  v-for="item in visitCustomerSalesmanDataList"
                  :label="`${item.userName} - ${item.loginId}`"
                  :value="item.code"
                  :key="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="addForm.contactVisible">
            <el-form-item label="联系人：" prop="contactId">
              <el-select clearable v-model="addForm.contactId">
                <el-option
                  :key="item.uid"
                  v-for="item in contactsSelect"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="是否完成：" prop="isFinished">
              <el-select
                clearable
                v-model="addForm.isFinished"
                @change="visitIsFinishedChange"
              >
                <we-yes-or-no-options v-once />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="拜访方式：" prop="visitType">
              <el-select clearable v-model="addForm.visitType">
                <el-option
                  :key="item.uid"
                  v-for="item in visitTypeList"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访时间：" prop="visitDateStr">
              <el-date-picker
                format="yyyy-MM-dd HH:mm:ss"
                :editable="false"
                value-format="yyyy-MM-dd  HH:mm:ss"
                v-model="addForm.visitDateStr"
                type="datetime"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="8"
            :offset="3"
            v-if="
              visitAuth.visitUploadFile &&
                visitAuth.visitUploadFile.toggleStatus
            "
          >
            <el-form-item label="上传图片：">
              <el-upload
                ref="upload"
                class="upload-demo"
                action="action"
                accept="image/jpg,image/png,image/bmp,image/jpeg,image/gif,image/ico"
                :http-request="handleUpdate"
                :before-upload="beforeAvatarUpload"
                :on-success="handleOnSuccess"
                :on-error="handleOnError"
                :on-preview="handlePictureCardPreview"
                :file-list="uploadList"
                list-type="picture-card"
                :before-remove="beforeRemove"
              >
                <i class="el-icon-plus"></i>
                <!-- <crm-button :text="'上传'"></crm-button> -->
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg、png、bmp、jpeg、gif、ico文件，且不超过5M
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访事宜：" prop="visitAim">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="最多200个字"
                v-model="addForm.visitAim"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="addForm.visitNoteVisible">
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访结果：" prop="visitNote">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="最多500个字"
                v-model="addForm.visitNote"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import VisitCusnameSelect from '@/components/business/visit/visit-cusname-select';
import VisitMedicalCusnameSelect from '@/components/business/visit/visit-medical-cusname-select';
import VisitBusiSelect from '@/components/business/visit/visit-busi-select';
import VisitCluesSelect from '@/components/business/visit/visit-clues-select';
import WeYesOrNoOptions from '~component/base/yes-or-no-options';
import visitObjectSelectTypes from '~component/business/visit/visit-object-select-types';
import { uploadFileVerify } from '@/scripts/reg';

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    VisitCusnameSelect,
    VisitBusiSelect,
    VisitCluesSelect,
    WeYesOrNoOptions,
    visitObjectSelectTypes,
    VisitMedicalCusnameSelect,
  },
  props: {
    visible: { type: Boolean },
    detail: { type: Object },
  },
  data() {
    return {
      // 待提交的表单数据
      addForm: {
        // 拜访对象: 拜访对象：1-客户，2-商机，3-线索 4-医生
        visitObjectId: '',
        visitObject: 1,

        customVisible: true,
        medicalCustomVisible: false,
        // 商机下拉展示
        buisVisible: false,
        // 线索下拉展示
        cluesVisible: false,
        contactVisible: true,

        // 客户
        customerId: null,
        customName: null,

        // 线索
        cluesId: null,
        cluesName: null,

        // 商机
        businessId: null,
        businessName: null,

        // 医生客户
        medicalCustomerId: null,
        medicalCustomName: null,

        visitDateStr: '',
        // 拜访事宜
        visitAim: '',
        salesmanCode: null,
        isFinished: '',
        // 拜访结果影藏
        visitNoteVisible: false,
        // 拜访结果
        visitNote: '',
        contactId: null,
        // 拜访方式
        visitType: '',
        // 文件
        fileId: '',
        canEdit: true,
      },
      // 文件图片
      uploadList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      // 联系人下拉框数据
      contactsSelect: [],
      // 联系人提交
      contactsList: {
        businessId: '',
        customerUid: '',
        salesmanCode: '',
        pageNumber: 1,
        pageSize: 50,
      },
      // 拜访方式
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
      },
      // 表单校验规则
      addFormRules: {
        customerId: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
        ],
        medicalCustomerId: [
          { required: true, message: '请选择医生客户名称', trigger: 'change' },
        ],
        businessId: [
          { required: true, message: '请选择商机名称', trigger: 'change' },
        ],
        cluesId: [
          { required: true, message: '请选择线索名称', trigger: 'change' },
        ],
        visitObject: [
          { required: true, message: '请选择拜访对象', trigger: 'change' },
        ],
        visitNote: [
          { required: true, message: '请填写拜访结果', trigger: 'change' },
          {
            min: 0,
            max: 500,
            message: '最多500个字',
            trigger: 'blur',
          },
        ],
        visitAim: [
          { required: true, message: '请填写拜访事宜', trigger: 'change' },
          {
            min: 0,
            max: 200,
            message: '最多200个字',
            trigger: 'blur',
          },
        ],
        visitDateStr: [
          { required: true, message: '请填写拜访时间', trigger: 'change' },
        ],
        salesmanCode: [
          { required: true, message: '请选择业务员', trigger: 'change' },
        ],
        contactId: [
          { required: true, message: '请选择联系人', trigger: 'change' },
        ],
        visitType: [
          { required: true, message: '请选择拜访方式', trigger: 'change' },
        ],
        isFinished: [
          { required: true, message: '请选择是否完成', trigger: 'change' },
        ],
      },
    };
  },
  async mounted() {
    await this.getAuthority({ menuUrl: '/visit' });
  },
  computed: {
    ...mapGetters({
      visitAuth: 'authority/visitAuth',
      userInfo: 'authority/userInfo',
      visitTypeList: 'visit/visitTypeList',
      visitCustomerDataList: 'visit/visitCustomerDataList',
      visitMedicalCustomerDataList: 'visit/visitMedicalCustomerDataList',
      visitCustomerSalesmanDataList: 'visit/visitCustomerSalesmanDataList',
      visitCustomerConvertDataList: 'visit/visitCustomerConvertDataList',
      visitBusinessDataList: 'visit/visitBusinessDataList',
      visitBusinessConvertDataList: 'visit/visitBusinessConvertDataList',
      visitCluesDataList: 'visit/visitCluesDataList',
    }),
  },
  // created() {
  //   console.log('created');
  //   // 业务员下拉
  //   // this.handleSelectSalesman();
  //   console.log('.,.,,,,,', this.crmAuth)
  // },
  watch: {
    visible: {
      handler() {
        this.getVisitCustomerSalesmanDataList().then(() => {
          this.addForm.salesmanCode = this.userInfo.userUid;
        });
        this.contactsSelect = [];
        this.uploadList = [];
        // if (this.addForm.visitObject === '1') {}
      },
      immediate: true,
    },
    detail: {
      handler() {
        if (this.detail) {
          console.log(this.detail, 'detail');
          this.addForm.visitObject = this.detail.visitObject;
          switch (this.addForm.visitObject) {
            case 1:
              this.contactsList.customerUid = this.detail.customerId;
              this.handleSelectConvert(this.detail.customerId);
              break;
            case 2:
              this.contactsList.businessId = this.detail.businessId;
              this.handleSelectBusiness(this.detail.businessId);
              break;
            case 3:
              break;
            default:
              this.contactsList.customerUid = this.detail.medicalCustomerId;
              this.handleSelectConvert(this.detail.medicalCustomerId);
              break;
          }
          // this.handleSelectVisitObject();
          this.addForm = Object.assign({}, this.addForm, this.detail);
          console.log(this.addForm, 'this.addForm');
          this.getVisitType({
            pageNumber: this.searchForm.pageNumber,
            pageSize: this.searchForm.pageSize,
            code: 'category_visit_type',
          });
          console.log(this.contactsList, 'this.contactsList');
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      getVisitCustomerDataList: 'visit/getVisitCustomerDataList',
      getVisitMedicalCustomerDataList: 'visit/getVisitMedicalCustomerDataList',
      getVisitCustomerSalesmanDataList:
        'visit/getVisitCustomerSalesmanDataList',
      getVisitCustomerConvertDataList: 'visit/getVisitCustomerConvertDataList',
      getVisitBusinessDataList: 'visit/getVisitBusinessDataList',
      getVisitBusinessConvertDataList: 'visit/getVisitBusinessConvertDataList',
      getVisitCluesDataList: 'visit/getVisitCluesDataList',
      visitUploadFile: 'visit/visitUploadFile',
      deleteVisitUploadFile: 'visit/deleteVisitUploadFile',
      addHandleVisit: 'visit/addHandleVisit',
      getAuthority: 'authority/getAuthority',
      getVisitType: 'visit/getVisitType',
    }),
    handleEmptyAddForm() {
      this.contactsSelect = [];
      this.addForm.contactId = '';
      this.addForm.businessId = '';
      this.addForm.visitObjectId = '';
      this.addForm.customerId = '';
      this.addForm.customName = '';
      this.addForm.medicalCustomerId = '';
      this.addForm.medicalCustomName = '';
      this.addForm.cluesId = '';

      this.contactsList = {
        businessId: '',
        customerUid: '',
        salesmanCode: '',
        pageNumber: 1,
        pageSize: 50,
      };
    },
    // 拜访类型选择
    handleSelectVisitObject(val) {
      this.handleEmptyAddForm();
      if (val) {
        this.addForm.visitObject = val;
      }
      if (this.addForm.visitObject === 1) {
        // 客户
        this.addForm.customVisible = true;
        this.addForm.contactVisible = true;

        // 商机下拉展示
        this.addForm.buisVisible = false;
        // 线索下拉展示
        this.addForm.cluesVisible = false;
      } else if (this.addForm.visitObject === 2) {
        // 商机

        this.addForm.customVisible = false;
        this.addForm.contactVisible = true;
        // 商机下拉展示
        this.addForm.buisVisible = true;
        // 线索下拉展示
        this.addForm.cluesVisible = false;
      } else if (this.addForm.visitObject === 3) {
        // 线索
        this.addForm.customVisible = false;
        this.addForm.contactVisible = false;
        // 商机下拉展示
        this.addForm.buisVisible = false;
        // 线索下拉展示
        this.addForm.cluesVisible = true;
      } else if (this.addForm.visitObject === 4) {
        // 医生客户
        this.addForm.customVisible = false;
        this.addForm.medicalCustomVisible = true;
        this.addForm.contactVisible = true;

        // 商机下拉展示
        this.addForm.buisVisible = false;
        // 线索下拉展示
        this.addForm.cluesVisible = false;
      }
    },
    // 客户选择
    handleSelectCustomer(value) {
      const customerData = this.visitCustomerDataList.results;
      console.log(
        this.visitCustomerDataList,
        'this.visitCustomerDataList.results',
      );
      console.log(value, 'handleSelectCustomer');

      // eslint-disable-next-line arrow-parens
      let cus = null;
      Object.keys(customerData).map((key) => {
        if (customerData[key].uid === value) {
          // eslint-disable-next-line no-const-assign
          cus = customerData[key];
        }
        // eslint-disable-next-line consistent-return
        return null;
      });

      if (cus !== null && cus.uid === value && cus.customerType === 2) {
        this.addForm.contactVisible = false;
      } else {
        this.addForm.contactVisible = true;
      }

      this.contactsSelect = [];
      this.addForm.customerId = value;
      this.contactsList.customerUid = value;
      this.contactsList.businessId = '';
      this.addForm.visitObjectId = value;
      this.addForm.contactId = '';
      if (value && this.addForm.contactVisible) {
        this.handleSelectConvert(value);
      } else {
        this.contactsSelect = [];
      }
    },
    // 医生客户选择
    handleSelectMedicalCustomer(value) {
      const customerData = this.visitMedicalCustomerDataList.results;
      // eslint-disable-next-line arrow-parens
      let cus = null;
      Object.keys(customerData).map((key) => {
        if (customerData[key].uid === value) {
          // eslint-disable-next-line no-const-assign
          cus = customerData[key];
        }
        // eslint-disable-next-line consistent-return
        return null;
      });

      if (cus !== null && cus.uid === value && cus.customerType === 2) {
        this.addForm.contactVisible = false;
      } else {
        this.addForm.contactVisible = true;
      }

      this.contactsSelect = [];
      this.addForm.medicalCustomerId = value;
      this.contactsList.customerUid = value;
      this.contactsList.businessId = '';
      this.addForm.visitObjectId = value;
      this.addForm.contactId = '';
      if (value && this.addForm.contactVisible) {
        this.handleSelectConvert(value);
      } else {
        this.contactsSelect = [];
      }
    },
    // 商机选择
    handleSelectBusiness(value) {
      this.contactsSelect = [];
      this.addForm.businessId = value;
      this.addForm.visitObjectId = value;
      this.contactsList.businessId = value;
      this.contactsList.customerUid = '';
      this.addForm.contactId = '';
      if (value) {
        this.handleSelectConvert(value);
      } else {
        this.contactsSelect = [];
      }
    },
    // 线索选择
    handleSelectClues(value) {
      this.contactsSelect = [];
      this.addForm.contactId = '';
      this.addForm.visitObjectId = value;
      this.addForm.cluesId = value;
    },
    // 联系人选择
    handleSelectConvert(val) {
      this.addForm.contactId = '';
      if (val) {
        // 客户联系人
        if (this.contactsList.customerUid) {
          this.getVisitCustomerConvertDataList(this.contactsList).then(() => {
            if (this.visitCustomerConvertDataList.results.length > 0) {
              this.contactsSelect = this.visitCustomerConvertDataList.results;
              this.addForm.contactId = this.contactsSelect[0].uid;
            }
          });
        }
        // 商机联系人
        if (this.contactsList.businessId) {
          this.getVisitBusinessConvertDataList(this.contactsList).then(() => {
            if (this.visitBusinessConvertDataList.results.length > 0) {
              this.contactsSelect = this.visitBusinessConvertDataList.results;
              this.addForm.contactId = this.contactsSelect[0].uid;
            }
          });
        }
      } else {
        this.contactsList = [];
      }
    },
    // 获取业务员
    handleSelectSalesman(val) {
      if (val) {
        this.addForm.salesmanCode = val;
      }
    },
    // 取消
    handleCancel() {
      this.$emit('close');
      this.handleEmptyAddForm();
      this.$refs.addForm.resetFields();
    },
    // 新增保存
    handleSave() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // this.addForm.addConverts = [];
          // this.addForm.addConverts = this.addForm.converts;
          const { id, visitObject, ...otherAddParams } = this.addForm;
          this.addHandleVisit({
            ...otherAddParams,
            visitObject,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '新增成功！',
            });
            this.$refs.addForm.resetFields();
            this.$emit('close');
            this.$emit('success');
          });
        }
      });
    },

    // 拜访是否完成
    visitIsFinishedChange() {
      if (this.addForm.isFinished === 1) {
        this.addForm.visitNoteVisible = true;
      } else if (this.addForm.isFinished === 0) {
        this.addForm.visitNoteVisible = false;
      } else {
        this.addForm.visitNoteVisible = false;
      }
    },
    // 文件上传
    handleOnError() {},
    // 图片展示
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 文件上传成功时同步文件列表
    handleOnSuccess(response, file, fileList) {
      // 覆盖上一个文件
      if (fileList !== null && fileList.length > 0) {
        this.uploadList = [fileList[fileList.length - 1]];
      } else {
        this.uploadList = fileList;
      }
    },
    // 文件上传前文件大小拦截
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        return Promise.reject();
      }
      /* eslint-disable */
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    // 展示的文件列表中删除文件，将传给后端的文件id删除
    beforeRemove(file) {
      const delIndex = this.uploadList.findIndex(item => item.url === file.url);
      if (delIndex !== -1) {
        this.deleteVisitUploadFile({
          id: this.addForm.fileId,
        }).then(() => {
          this.addForm.fileId = '';
        });
      }
      return true;
    },
    // 文件上传
    handleUpdate(item) {
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在上传中，请稍后...',
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append('file', item.file);
      params.append('fileName', item.file.name);
      this.visitUploadFile({
        params,
        config: { 'Content-Type': 'multipart/form-data', timeout: 100000 },
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: '上传成功！',
          });
          item.onSuccess();
          this.addForm.fileId = res.data.data;
        })
        .catch(() => {
          item.onError();
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.el-list-enter-active,
.el-list-leave-active {
  transition: none;
}

.el-list-enter,
.el-list-leave-active {
  opacity: 0;
}
.el-upload-list {
  height: 40px;
}

.el-select {
  width: 200px;
}
.el-textarea .upload-demo {
  width: 400px;
}
.el-input__inner {
  width: 200px;
}
</style>
